// types of answers for questions accepted on the backend
enum BackendQuestionMessageAnswerMethod {
  FREE_INPUT = 'input',
  PREDEFINED = 'reply',
  BOTH = 'any',
  API = 'api',
}

export default BackendQuestionMessageAnswerMethod
